// General
export const NAVBAR_TOGGLE = "navbar-toggle";

// Dashboard
export const DASHBOARD_CHALLENGES = "dashboard-active-challenges-list";
export const DASHBOARD_RECENT_TRYPS = "dashboard-recent-tryps-list";
export const DASHBOARD_SRC = "dashboard-src-list";

// Stats and Scores
export const STATS_CARD_BASE = (id) => `stats-card-${id}`;
export const STATS_GAUGE = "stats-overall-gauge";
export const FLIPPY_CARD_EVENTS = "events";
export const FLIPPY_CARD_DRIVER_SCORE = "driverScore";
export const FLIPPY_CARD_NUM_TRIPS = "numTrips";

// Level Up
export const LEVEL_UP_CAT_VIDEO = (category) =>
  `levelup-${category}-video-area`;
export const LEVEL_UP_VOTW_AREA = "levelup-votw-reco-area";
export const LEVEL_UP_CAT_BUTTON = (category) =>
  `levelup-cat-button-${category}`;

// SRC Leaderboard
export const SRC_LEADERBOARD_AREA = "leaderboard-leaderboard-area";
export const SRC_TIER_NAV = (tierId) => `leaderboard-tier-nav-${tierId}`;
export const SRC_NO_COMP_ERROR = "leaderboard-error-no-comp-page";

// Challenges
export const CHALLENGES_NO_COMP_ERROR = "competition-info-error-no-comp-page";
export const CHALLENGES_MAIN_AREA = "challenges-main-area";
export const CHALLENGES_CARD_ID = (id) => `challenges-challenge-card-${id}`;
export const CHALLENGES_CARD_AREA = "challenges-challenges-area";
export const CHALLENGES_PRIZE_AREA = "challenges-prize-area";
export const CHALLENGES_POOL_AREA = "challenges-pool-area";
export const CHALLENGES_WINNER_AREA = (section) =>
  `challenges-${section}-winner-area`;
export const CHALLENGES_SELF_IMPROVEMENT_AREA =
  "challenges-self-improvement-area";
